export const UNASSIGNED_RECORD_KEY = '';
